export default __webpack_public_path__ + "static/media/Placement_Brochure_2022-23.90b89dee.pdf";